const config = {
  backendUrl: 'https://dec0-2601-646-0-36e0-4835-1d37-43fa-d2d.ngrok-free.app'
  // backendUrl: 'https://youingest-production.up.railway.app'
};

export default config; 